import { render, staticRenderFns } from "./ProfessorGeneroCard.vue?vue&type=template&id=41eee0f4&scoped=true"
import script from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
export * from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorGeneroCard.vue?vue&type=style&index=0&id=41eee0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eee0f4",
  null
  
)

export default component.exports